import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AppProvider } from "./context/AppContext";
import Header from "./components/Header";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Favorites from "./pages/Favorites";
import AuthCallback from "./pages/AuthCallback";
import GroupVote from "./pages/GroupVote";

function AppRouter() {
  const location = useLocation();
  // Synchronous check: process OAuth callback BEFORE normal routes
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/favorites" element={<Favorites />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/g/:id" element={<GroupVote />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-[#FAF7F2] text-stone-900 antialiased">
      <BrowserRouter>
        <AppProvider>
          <AppRouter />
          <Toaster position="top-right" richColors />
        </AppProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
